import { odooApi } from '../index';
import { getOdooLang } from '@/config/api.config';
import { extractErrorMessage } from '../transforms';

/**
 * About Ministry API Endpoints (Connected to Odoo Backend)
 * 
 * This file contains ministry/minister information API endpoints.
 * Connected to real Odoo API at /api/moys/about
 */

export interface AboutMinistry {
  id: string;
  ministerName: string;
  ministerTitle: string;
  ministerLocation: string;
  ministerImage: string | null;
  ministerBio: string;
  awardsCount: number;
  achievementsCount: number;
  projectsCount: number;
  publicationsCount: number;
  missionDescription: string;
  visionDescription: string;
  values: Array<{
    title: string;
    description: string;
    iconColor: string;
  }>;
}

export const aboutApi = odooApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get about ministry information from Odoo
    getAbout: builder.query<AboutMinistry, { lang?: 'ar' | 'en' | 'ku' }>({
      query: ({ lang = 'ar' }) => {
        const odooLang = getOdooLang(lang);
        
        return {
          url: `/api/moys/about?lang=${odooLang}`,
          method: 'POST',
        };
      },
      transformResponse: (response: any) => {
        try {
          if (!response.success || !response.data) {
            throw new Error('Invalid response format');
          }
          
          const data = response.data;
          
          return {
            id: String(data.id),
            ministerName: data.minister_name || '',
            ministerTitle: data.minister_title || '',
            ministerLocation: data.minister_location || '',
            ministerImage: data.minister_image || null,
            ministerBio: data.minister_bio || '',
            awardsCount: data.awards_count || 0,
            achievementsCount: data.achievements_count || 0,
            projectsCount: data.projects_count || 0,
            publicationsCount: data.publications_count || 0,
            missionDescription: data.mission_description || '',
            visionDescription: data.vision_description || '',
            values: (data.values || []).map((v: any) => ({
              title: v.title || '',
              description: v.description || '',
              iconColor: v.icon_color || v.iconColor || '#007bff',
            })),
          } as AboutMinistry;
        } catch (error) {
          console.error('[About API] Transform error:', error);
          throw error;
        }
      },
      transformErrorResponse: (response) => {
        return extractErrorMessage(response);
      },
      providesTags: ['Settings'],
    }),
  }),
});

export const {
  useGetAboutQuery,
} = aboutApi;

